import React, { useRef, useState } from 'react';
import { useDetectIfOverflowBottom } from 'hooks/useDetectIfOverflowBottom';
import { CSSTransition } from 'react-transition-group';
import { Arrow, SelectListWrapper } from './SelectListStyles';

interface IProps {
  children: any;
  visible: boolean;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  isBelowBottomCallback?: (isBelowBottom: boolean) => void;
}

export const SelectList: React.FC<IProps> = (props) => {
  const { children, visible, top, right, bottom, left, isBelowBottomCallback } = props;
  const [isBelowBottom, setIsBelowBottom] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useDetectIfOverflowBottom(ref, visible, (effect) => handleUseDetectIfOverflowBottom(effect));

  const handleUseDetectIfOverflowBottom = (effect: boolean) => {
    isBelowBottomCallback && isBelowBottomCallback(effect);
    setIsBelowBottom(effect);
  };

  return (
    <CSSTransition in={visible} timeout={200}>
      <>
        {visible && (
          <SelectListWrapper ref={ref} style={{ top, right, bottom, left }}>
            <Arrow className={`${isBelowBottom ? 'below' : ''}`} />
            {children}
          </SelectListWrapper>
        )}
      </>
    </CSSTransition>
  );
};
